import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import { QuestionsContext } from "../../../../../../provider/MyContexts";
import { questionTypes } from "../../../../../../config";
// import { ArrowBack, ArrowForward } from "@mui/icons-material";

type Props = {};

export default function TitleArea(props: Props) {
  const {} = props;
  const { selectedQuestion, handleChangeQuestionType, updateQuestionValue, isLoading } =
    useContext(QuestionsContext);

  const [title, setTitle] = useState<string>("");
  const [condition, setCondition] = useState<string>("");

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };
  const handleConditionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCondition(e.target.value);
  };

  const syncState = (key: string) => {
    if (key === "questionTitle") {
      updateQuestionValue("questionTitle", title);
    } else if (key === "condition") {
      updateQuestionValue("condition", condition);
    }
  };

  useEffect(() => {
    setTitle(selectedQuestion.questionTitle);
    setCondition(selectedQuestion.condition);
  }, [selectedQuestion]);

  return (
    <Stack
      direction={"column"}
      spacing={1}
      width={"100%"}
      // marginBottom={2}
      sx={{
        position: "relative",
      }}
    >
      <Typography variant="heading_S" paddingBottom={1} fontWeight={600}>
        {selectedQuestion.questionId}
      </Typography>
      <Stack direction={"row"} spacing={2} justifyContent={"center"}>
        <TextField
          value={title}
          label={"設問タイトル"}
          variant="outlined"
          sx={{ flex: 1 }}
          size="small"
          onChange={handleTitleChange}
          disabled={isLoading}
          onBlur={() => syncState("questionTitle")}
        />
        <FormControl sx={{ width: 96 }} size="small">
          <InputLabel id="qType-select-label">回答形式</InputLabel>
          <Select
            labelId="qType-select-label"
            id="qType-select"
            value={selectedQuestion.questionType}
            onChange={(e) => handleChangeQuestionType(e.target.value)}
            size="small"
            label={"回答形式"}
            disabled={isLoading}
          >
            {questionTypes.map((elm, index) => (
              <MenuItem key={index} value={elm}>{`${elm}`}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      <Stack direction={"row"} spacing={2} justifyContent={"center"}>
        <TextField
          value={condition}
          onChange={handleConditionChange}
          onBlur={() => syncState("condition")}
          disabled={isLoading}
          label={"表示条件"}
          sx={{ flex: 1 }}
          size="small"
        />

        <RandomSelect />
        <PageBrSelect />
      </Stack>
      <Divider flexItem />
    </Stack>
  );
}

export function RandomSelect() {
  const { selectedQuestion } = useContext(QuestionsContext);

  const label = "ランダム設定";

  return (
    <FormControl
      size="small"
      fullWidth
      sx={{
        width: 160,
      }}
    >
      <InputLabel id="qType-select-label">{label}</InputLabel>
      <Select
        labelId="qType-select-label"
        id="qType-select"
        value={selectedQuestion.random}
        disabled
        // onChange={(e: any) => handleChangeSheet(e)}
        size="small"
        sx={{
          fontSize: "1rem",
          textAlign: "center",
        }}
        label={label}
      >
        {["なし", "ランダム", "G間ランダム"].map((elm, index) => (
          <MenuItem key={index} value={elm}>{`${elm}`}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export function PageBrSelect() {
  const { selectedQuestion } = useContext(QuestionsContext);

  const label = "前改ページ";

  return (
    <FormControl
      size="small"
      fullWidth
      sx={{
        width: 96,
      }}
    >
      <InputLabel id="qType-select-label">{label}</InputLabel>
      <Select
        labelId="qType-select-label"
        id="qType-select"
        value={selectedQuestion.forwardPageBreak ? "あり" : "なし"}
        disabled
        // onChange={(e: any) => handleChangeSheet(e)}
        size="small"
        sx={{
          fontSize: "1rem",
          textAlign: "center",
        }}
        label={label}
      >
        {["あり", "なし"].map((elm, index) => (
          <MenuItem key={index} value={elm}>{`${elm}`}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
